import type { KyInstance } from 'ky';

import { convertToQueryString, ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { GetTagCategoriesQuery } from './types/get-tag-categories-query.type';
import type { TagCategory } from './types/tag-category.type';

/**
 * Fetches a list of tag categories from the API using the provided Ky HTTP client instance and query parameters.
 *
 * @param instance - The KyInstance used to make the HTTP request.
 * @param query - The query parameters for filtering and sorting tag categories.
 * @returns A promise that resolves to an OperationResultWithData containing an array of TagCategory objects.
 * @throws Will throw an error if the HTTP request fails.
 */
export const getTagCategories = async (instance: KyInstance, query: GetTagCategoriesQuery) => {
  try {
    const { sort, ...searchParams } = query;

    return await instance
      .get<OperationResultWithData<TagCategory[]>>(Uri.tags.getTagCategories, {
        searchParams: {
          ...searchParams,
          ...convertToQueryString(sort, 'sort'),
        },
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
